import React, { useEffect, useState } from 'react';
import { isBlank } from 'utils/helperMethods';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Typography, Link } from '@material-ui/core';
import Seo from 'sharedComponents/Seo';
import Loader from 'sharedComponents/Loader';
import { appRoutes } from 'routes';

import RealEstateAgentPresenter from 'presenters/RealEstateAgentPresenter';
import useRealEstateAgents from 'reducers/hooks/public/useRealEstateAgents';
import useBuyer from 'reducers/hooks/useBuyer';

import TopBar from './components/TopBar';
import FavoriteLoanOfficersList from './components/FavoriteLoanOfficersList';
import Guide from './components/Guide';
import BuyerRegistration from './components/BuyerRegistration';

import useStyles from './useStyles';

const ReferralRealEstateAgent = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { slug } = useParams();

  const {
    loadRealEstateAgent,
    isRealEstateAgentLoading,
    isRealEstateAgentIdle,
    realEstateAgent,
  } = useRealEstateAgents();

  const { setRealEstateAgentReferral } = useBuyer();

  useEffect(() => {
    loadRealEstateAgent(slug);
  }, []);

  const [signUpPopupOpened, setSignupPopupOpened] = useState(false);

  if (isRealEstateAgentLoading || isRealEstateAgentIdle) {
    return (
      <div className={classes.box}>
        <Loader />
      </div>
    );
  }

  if (isBlank(realEstateAgent)) {
    return (
      <div className={classes.box}>
        <Typography variant="h1">{t('components.ReferralRealEstateAgent.notFound')}</Typography>
        <Link component={RouterLink} className={classes.link} to={appRoutes.rootPath()}>
          {t('components.ReferralRealEstateAgent.goBack')}
        </Link>
      </div>
    );
  }

  const loanOfficers = RealEstateAgentPresenter.activeFavoriteLoanOfficers(realEstateAgent);
  const handleClickStarted = () => setSignupPopupOpened(true);
  const handleCloseSignupPopup = () => setSignupPopupOpened(false);

  const handleFinish = () => {
    setRealEstateAgentReferral(slug);
  };

  return (
    <div className={classes.container}>
      <Seo
        title={t('meta.ReferralRealEstateAgent.title')}
        description={t('meta.ReferralRealEstateAgent.description')}
      />
      <TopBar realEstateAgent={realEstateAgent} onStart={handleClickStarted} />
      <div className={classes.content}>
        <div className={classes.paper}>
          <Guide onStart={handleClickStarted} realEstateAgent={realEstateAgent} />
          <FavoriteLoanOfficersList loanOfficers={loanOfficers} realEstateAgent={realEstateAgent} />
        </div>
      </div>
      {signUpPopupOpened && <BuyerRegistration onClose={handleCloseSignupPopup} onFinish={handleFinish} />}
    </div>
  );
};

export default ReferralRealEstateAgent;



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/ReferralRealEstateAgent.js